module.exports = {
	"order": "รายการชื้อ",
	"view": "บิลทั้งหมด",
	"edit": "แก้ไขรายการชื้อ",
	"orderCreate": "สร้างบิล",
	"code": "รหัสรายการ",
	"orderDate": "วันทำรายการ",
	"productDetail": "ข้อมูลสินค้า",
	"orderDatePlaceholder": "เลือกวันที่",
	"reference": "หมายเลขอ้างอิง",
	"addMoreProduct": "เพิ่มรายการ",
	"deliveryDetail": "รายละเอียดการจัดส่ง",
	"deliveryDate": "วันที่ส่ง",
	"useDate": "ใช้งาน",
	"returnDate": "กำหนดส่งคืน",
	"address": "ที่อยู่ในการจัดส่ง / เซทอัพ",
	"receiverPhoneNumber": "เบอร์ติดต่อ (ส่งสินค้า)",
	"deliveryTime": "เวลาที่สะดวก",
	"deliveryPrice": "ค่าจัดส่ง",
	"deliveryTimePlaceholder": "กรุณาเลือกเวลาที่ส่ง",
	"deliveryType": "วิธีการจัดส่ง",
	"deliveryTypePlaceholder": "กรุณาเลือกวิธีการจัดส่งสินค้า",
	"discount": "ส่วนลด %",
	"totalPrice": "ยอดรวมทั้งสิ้น",
	"productRefCodePlaceholder": "เลือกรหัสสินค้า",
	"deleteConfirmText": "ทำการลบรายการเช่า",
	"deliveryName": "ชื่อผู้รับสินค้า",
	"deliveryPlaceName": "ชื่อที่สถานที่",
	"setupPrice": "ค่าบริการเซ็ทอัพ",
	"tax": "ภาษีมูลค่าเพิ่ม",
	"remark": "เพิ่มเติม",
	"chooseAddress": "เลือกที่อยู่",
	"select": "เลือก",
	"setExtra": "แก้ไขรายละเอียดเพิ่มเติม",
	"billNumber": "เลขที่บิล",
	"state": "สถานะ"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/order.json
// module id = 838
// module chunks = 1